import { useResource } from "hooks/useResource";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CompanyList from "../components/CompanyList";
import FormAgendaNotes from "../forms/FormAgendaNotes";
import LayoutAgendaSteps from "./LayoutAgendaSteps";

export default function PageCreateAgendaTopics() {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();
  const { data: agenda } = useResource({
    id,
    resourceName: "agenda",
    path: "agendas",
  });

  if (agenda && agenda.email) navigate(`/disparos-de-agenda${location.search}`);

  return (
    <LayoutAgendaSteps activeStepIndex={1}>
      {agenda && (
        <>
          <FormAgendaNotes agenda={agenda} />
          <CompanyList contentGroup={agenda.contentGroup} list={agenda.list} />
        </>
      )}
    </LayoutAgendaSteps>
  );
}
